import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@hooks/useStores';
import { UserIcon, ChevronDownIcon } from '@components/common/ui/icons';
import { getUserInitials } from '@components/common/layout/topbar/utils';
import { useDropdownPlacement } from '@hooks/useDropdownPlacement';
import * as styles from '@components/common/layout/topbar/TopBar.module.css';

const cn = (...classes: (string | undefined | false)[]) => classes.filter(Boolean).join(' ');

export const UserMenu: React.FC = observer(() => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const authStore = useAuthStore();
    const [showUserMenu, setShowUserMenu] = useState(false);
    const userMenuRef = useRef<HTMLDivElement>(null);
    const placement = useDropdownPlacement(userMenuRef, showUserMenu, 200);

    // Закрытие меню при клике вне его
    useEffect(() => {
        const handleClickOutside = (event: Event) => {
            if (userMenuRef.current && !userMenuRef.current.contains(event.target as Node)) {
                setShowUserMenu(false);
            }
        };

        if (showUserMenu) {
            document.addEventListener('pointerdown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('pointerdown', handleClickOutside);
        };
    }, [showUserMenu]);

    const handleSignOut = () => {
        authStore.logout();
        navigate('/');
    };

    const userDisplayName =
        authStore.user?.name ||
        authStore.user?.login ||
        authStore.user?.username ||
        authStore.user?.email ||
        t('userMenu.userFallback');

    return (
        <div className={styles.userMenu} ref={userMenuRef}>
            <button
                className={cn(styles.button, styles.buttonGhost, styles.userButton)}
                onClick={() => setShowUserMenu(!showUserMenu)}
                title={userDisplayName}
            >
                <div className={styles.avatar}>
                    {authStore.user?.avatarUrl ? (
                        <img src={authStore.user.avatarUrl} alt={userDisplayName} />
                    ) : (
                        <span className={cn(styles.avatarFallback, styles.avatarFallbackPrimary)}>
                            {authStore.user ? (
                                getUserInitials(authStore.user)
                            ) : (
                                <UserIcon className={styles.iconSmall} />
                            )}
                        </span>
                    )}
                </div>
                <ChevronDownIcon className={styles.userMenuChevron} />
            </button>

            {showUserMenu && (
                <div className={`${styles.dropdownMenu}${placement === 'top' ? ` ${styles.dropdownMenuUp}` : ''}`}>
                    <button
                        className={styles.dropdownItem}
                        onClick={() => {
                            setShowUserMenu(false);
                            navigate('/profile');
                        }}
                    >
                        <UserIcon className={styles.iconSmall} />
                        <span>{t('userMenu.profile')}</span>
                    </button>
                    {/* <button
            className={styles.dropdownItem}
            onClick={() => {
              setShowUserMenu(false);
              navigate('/settings');
            }}
          >
            <UsersIcon className={styles.iconSmall} />
            <span>Settings</span>
          </button> */}
                    <div className={styles.dropdownSeparator} />
                    <button
                        className={cn(styles.dropdownItem, styles.dropdownItemDanger)}
                        onClick={handleSignOut}
                    >
                        <span>{t('userMenu.signOut')}</span>
                    </button>
                </div>
            )}
        </div>
    );
});
